





































































import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import LocationLookupDropdown from '@/Shared/LocationLookupDropdown.vue';
import constants from '@/constants';
import { BRow } from 'bootstrap-vue';
import { Logger } from '@/Shared/Logger';
import { CustomerAddressParent } from '@/Admin/CustomerAlias/CustomerAddressParent';
import { CustomerAddressChild } from '@/Admin/CustomerAlias/CustomerAddressChild';
import {TranslateResult} from 'vue-i18n';
import { IDefaultGridColumns } from '@/Shared/IDefaultGridColumns';

const CustomerAlias = Vue.extend({
    props: ['location'],
    components: { LocationLookupDropdown },
    computed: {
        parentFields(): Array<IDefaultGridColumns<CustomerAddressParent>> {
            return [
                { key: 'recID', label: this.$t('admin.customerAlias.recidHeader') },
                { key: 'name', label: this.$t('admin.customerAlias.parentNameHeader') },
                { key: 'description', label: this.$t('admin.customerAlias.parentDescriptionHeader') },
                { key: 'address1', label: this.$t('admin.customerAlias.parentAddressHeader') },
                { key: 'city', label: this.$t('admin.customerAlias.parentCityHeader') },
                { key: 'state', label: this.$t('admin.customerAlias.parentStateHeader') },
                { key: 'zip', label: this.$t('admin.customerAlias.parentZipHeader') },
                { key: 'actions', label: this.$t('common.actions') }
            ];
        },
        childFields(): Array<IDefaultGridColumns<CustomerAddressChild>> {
            return [
                { key: 'recID', label: this.$t('admin.customerAlias.recidHeader') },
                { key: 'lastName', label: this.$t('admin.customerAlias.childLastNameHeader') },
                { key: 'firstName', label: this.$t('admin.customerAlias.childFirstNameHeader') },
                { key: 'middleName', label: this.$t('admin.customerAlias.childMiddleNameHeader') },
                { key: 'parentRecID', label: this.$t('admin.customerAlias.childParentRecidHeader') },
                { key: 'actions', label: this.$t('common.actions') }
            ];
        }
    },
    data() {
        return {
            customerParentList: [] as CustomerAddressParent[],
            customerChildList: [] as CustomerAddressChild[],
            customerParentRowEditing: {} as { [key: number]: CustomerAddressParent },
            customerChildRowEditing: {} as { [key: number]: CustomerAddressChild },
            selectedParentRow: new CustomerAddressParent(),
            showChildTable: false
        };
    },
    methods: {
        async getCustomerParentTableList() {
            try {
                this.customerParentList = (await VatsAPI.get<CustomerAddressParent[]>(`/${this.location}/customeralias/getcustomerparenttablelist`)).data;
            }
            catch (e) {
                Logger.Log(e.message);
            }
        },
        toggleRowEditing(row: BRow) {
            row.item.editing = !row.item.editing;
        },
        removeItemFromParentTable(item: CustomerAddressParent) {
            this.customerParentList.splice(this.customerParentList.indexOf(item), 1);
        },
        addNewParentRow() {
            const newItem = new CustomerAddressParent();
            newItem.editing = true;
            this.customerParentList.push(newItem);
        },
        enableParentRowEdit(row: BRow) {
            this.toggleRowEditing(row);
            this.customerParentRowEditing[row.item.recID] = Object.assign({}, row.item);
            this.$root.$emit('bv::refresh::table', 'parentTable');
        },
        cancelParentRowEdit(row: BRow) {
            if (row.item.recID === 0) {
                this.removeItemFromParentTable(row.item);
                return;
            }

            Object.assign(row.item, this.customerParentRowEditing[row.item.recID]);

            delete this.customerParentRowEditing[row.item.recID];

            this.toggleRowEditing(row);

            this.$root.$emit('bv::refresh::table', 'parentTable');
        },
        async upsertParentRow(row: BRow) {
            const item: CustomerAddressParent = row.item;

            const url = `/${this.location}/customeralias/upsertcustomerparent`;

            item.recID = (await VatsAPI.post<number>(url, item)).data;

            row.item.recID = item.recID;

            this.toggleRowEditing(row);

            this.$root.$emit('bv::refresh::table', 'parentTable');
        },
        async selectParentRow(row: BRow) {
            this.customerParentList.forEach((item: CustomerAddressParent) => {
                item.selected = false;
            });
            this.selectedParentRow = row.item;
            row.item.selected = true;
            try {
                this.customerChildList = (await VatsAPI.get<CustomerAddressChild[]>(`/${this.location}/customeralias/getcustomerchilddetails`, {
                    params: {
                        parentID: row.item.recID
                    }
                })).data;
            }
            catch (e) {
                Logger.Log(e.message);
            }
            this.showChildTable = true;
        },
        async deleteParentRow(row: BRow) {
            const item: CustomerAddressParent = row.item;

            const msgBoxOptions = {
                centered: true,
                okVariant: 'danger',
                modalClass: 'deleteRowClass',
                hideBackdrop: true
            };

            const message: TranslateResult =
                this.$t( 'admin.customerAlias.parentConfirmDeleteMessage', {
                    name: item.name,
                    description: item.description,
                    address: item.address1,
                    city: item.city,
                    state: item.state,
                    zip: item.zip
                });

            if (!await this.$bvModal.msgBoxConfirm(message.toString(), msgBoxOptions)) {
                return;
            }

            await VatsAPI.put(`${this.location}/customeralias/deletecustomerparent`, item);

            this.removeItemFromParentTable(item);
            this.customerChildList = [] as CustomerAddressChild[];
            this.selectedParentRow = new CustomerAddressParent();
            this.showChildTable = false;
        },
        removeItemFromChildTable(item: CustomerAddressChild) {
            this.customerChildList.splice(this.customerChildList.indexOf(item, 1));
        },
        addNewChildRow() {
            const newItem = new CustomerAddressChild();
            newItem.parentRecID = this.selectedParentRow.recID;
            newItem.editing = true;
            this.customerChildList.push(newItem);
        },
        enableChildRowEdit(row: BRow) {
            this.toggleRowEditing(row);
            this.customerChildRowEditing[row.item.recID] = Object.assign({}, row.item);

            this.$root.$emit('bv::refresh::table', 'childTable');
        },
        cancelChildRowEdit(row: BRow) {
            if (row.item.recID === 0) {
                this.removeItemFromChildTable(row.item);
                return;
            }

            Object.assign(row.item, this.customerChildRowEditing[row.item.recID]);

            delete this.customerChildRowEditing[row.item.recID];

            this.toggleRowEditing(row);

            this.$root.$emit('bv::refresh::table', 'childTable');
        },
        async upsertChildRow(row: BRow) {
            const item: CustomerAddressChild = row.item;

            const url = `/${this.location}/customeralias/upsertcustomerchilddetails`;

            item.recID = (await VatsAPI.post<number>(url, item)).data;

            row.item.recID = item.recID;

            this.toggleRowEditing(row);

            this.$root.$emit('bv::refresh::table', 'childTable');
        },
        async deleteChildRow(row: BRow) {
            const item: CustomerAddressChild = row.item;

            const msgBoxOptions = {
                centered: true,
                okVariant: 'danger',
                modalClass: 'deleteRowClass',
                hideBackdrop: true
            };

            const message: TranslateResult =
                this.$t('admin.customerAlias.childConfirmDeleteMessage',
                    {lastName: item.lastName, firstName: item.firstName, middleName: item.middleName});

            if (!await this.$bvModal.msgBoxConfirm(message.toString(), msgBoxOptions)) {
                return;
            }

            await VatsAPI.put(`${this.location}/customeralias/deletecustomerchilddetails`, item);

            this.removeItemFromChildTable(item);
        },
        rowClass(item: CustomerAddressParent, type: string) {
            if (!item) {
                return;
            }
            if (item.selected) {
                return 'table-success';
            }
        }
    },
    async mounted() {
        await this.getCustomerParentTableList();
    },
    watch: {
        async [constants.LocationParamPath]() {
            await this.getCustomerParentTableList();
            this.customerChildList = [] as CustomerAddressChild[];
            this.selectedParentRow = new CustomerAddressParent();
            this.showChildTable = false;
        }
    }
});
export default CustomerAlias;
